import React from "react";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import "./Footer.css";

export function Footer() {
  return (
    <div className={"footer-container"}>
      <div className={"link-list"}>
        <div className={"link-column"}>
          <div className={"link-title"}>
            <h4>Call:</h4>
            <a className={"link-item"} href="tel:+47637348">
              +47637348
            </a>
          </div>
        </div>
        <div className={"link-column"}>
          <div className={"link-title"}>
            <h4>Email:</h4>
            <a className={"link-item"} href="mailto:andreasbaade15@gmail.com">
              andreasbaade15@gmail.com
            </a>
          </div>
        </div>
      </div>
      <div className={"social-icon-container"}>
        <div className={"social-container"}>
          <div className={"social-icon"}>
            <a href={"https://www.linkedin.com/in/andreas-baade-958bba244/"}>
              <AiFillLinkedin size="3rem" />
            </a>
            <a href={"https://github.com/a-baade"}>
              <AiFillGithub size="3rem" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
